import React from 'react';

interface Option {
  label: string;
  value?: string;
  color?: string;
}

interface FilterButtonGroupProps {
  options: Option[];
  activeOption: string | string[];
  onClick: (label: string) => void;
  isOptionDisabled?: (option: Option) => boolean;
  className?: string;
}

export const FilterButtonGroupWithLabel: React.FC<FilterButtonGroupProps> = ({
  options,
  activeOption,
  onClick,
  isOptionDisabled,
  className = '',
}) => {
  return (
    <div className={`flex flex-wrap gap-2 pr-2 sm:justify-end ${className}`}>
      {options.map((option, index) => {
        const isActive =
          (typeof activeOption === 'string' && activeOption === option.label) ||
          (Array.isArray(activeOption) && activeOption.includes(option.label));
        const isDisabled = isOptionDisabled?.(option) || false;

        return (
          <button
            key={index}
            type="button"
            disabled={isDisabled}
            className={`items-center rounded-[4px] border px-2 py-1.5 text-xs font-semibold leading-tight
            transition-colors sm:px-3 sm:py-2 sm:leading-none
            ${
              isActive
                ? 'bg-white text-brand-primary'
                : isDisabled
                ? 'cursor-not-allowed border-gray-700 text-gray-600'
                : 'text-white'
            }`}
            style={{
              backgroundColor: isActive && option.color ? option.color : undefined,
              color: isActive && option.color ? '#ffff' : undefined,
              borderColor: isActive && option.color ? option.color : undefined,
            }}
            onClick={() => onClick(option.label)}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
};
